var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"layerManage"},[_c('el-tree',{ref:"tree",attrs:{"default-checked-keys":_vm.defaultList,"expand-on-click-node":false,"data":_vm.Listdata,"show-checkbox":"","default-expand-all":"","node-key":"name","highlight-current":"","props":_vm.defaultProps},on:{"check-change":_vm.checkChange,"node-click":_vm.handleNodeClick}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }